//Hook theme light and dark
import { useState } from 'react';
import { createTheme } from '@nextui-org/react';

export const useThemes = () => {
    const [theme, setTheme] = useState(createTheme({ type: 'light' }));

    const toggleTheme = () => {
        setTheme(theme.selector === '.light-theme' ? createTheme({ type: 'dark' }) : createTheme({ type: 'light' }));
    };

    return [theme, toggleTheme];
}
